import { autocompleteClasses } from '@mui/material/Autocomplete';
import Popper from '@mui/material/Popper';
// @mui/material/styles carries the MUI Theme; @mui/system's styled does not, which left
// `theme.zIndex` untyped here. The rest of the codebase imports it from material/styles.
import { styled } from '@mui/material/styles';

export const StyledAutocompletePopper = styled('div')(() => ({
  [`& .${autocompleteClasses.paper}`]: {
    boxShadow: 'none'
  },
  [`& .${autocompleteClasses.listbox}`]: {
    padding: 0
  }
}));

export const StyledPopper = styled(Popper)(({ theme }) => ({
  boxShadow: '0 8px 24px rgba(149, 157, 165, 0.2)',
  borderRadius: 8,
  zIndex: theme.zIndex?.modal || 1300,
  backgroundColor: '#fff',
  '& .MuiAutocomplete-popper': {
    width: 'auto !important',
    '& .MuiAutocomplete-option': {
      height: '5.4rem',
      padding: '1.6rem 2rem !important',
      borderBottom: 'none !important',
      fontWeight: 400,
      fontSize: '1.6rem',
      lineHeight: '2.2rem',
      color: theme.palette?.text?.primary || '#000'
    },
    '& .MuiAutocomplete-option.Mui-focused': {
      backgroundColor: `${theme.palette?.action?.hover || 'rgba(0, 0, 0, 0.04)'} !important`
    }
  }
}));

interface PopperComponentProps {
  anchorEl?: any;
  disablePortal?: boolean;
  open: boolean;
}

export function PopperComponent(props: PopperComponentProps) {
  const { disablePortal, anchorEl, open, ...other } = props;
  return <StyledAutocompletePopper {...other} />;
}
